'use strict';
module.exports = /<!--([\s\S]*?)-->/g;



//////////////////
// WEBPACK FOOTER
// ./~/html-comment-regex/index.js
// module id = 3007
// module chunks = 0